import {StoreCheckoutSettings} from '@wix/wixstores-graphql-schema-node';
import {ValueEnabledModel} from '../common/ValueEnabled.model';
import {ValueEnabledTitleModel} from '../common/ValueEnabledTitle.model';
import {CheckoutHeaderModel} from '../common/CheckoutHeader.model';
import {EcommerceSettings} from '@wix/wixstores-client-storefront-sdk';

export class PaymentRequestSettingsModel {
  public storeName?: string;
  public logoUrl?: string;
  public termsAndConditions: ValueEnabledModel;
  public privacyPolicy: ValueEnabledModel;
  public returnPolicy: ValueEnabledModel;
  public digitalPolicy: ValueEnabledModel;
  public contactUs: ValueEnabledModel;
  public customPolicy: ValueEnabledTitleModel;
  public isThereAnyPolicyEnabled: boolean;
  public checkoutHeader?: CheckoutHeaderModel;

  constructor({
    paymentRequestSettings,
    ecommerceSettings,
    shouldUseEcommerceSettings,
  }: {
    paymentRequestSettings?: StoreCheckoutSettings;
    ecommerceSettings?: EcommerceSettings;
    shouldUseEcommerceSettings: boolean;
  }) {
    if (shouldUseEcommerceSettings) {
      this.storeName = ecommerceSettings?.businessInfo?.storeName ?? undefined;
      this.logoUrl = ecommerceSettings?.businessInfo?.logo ?? undefined;
      this.termsAndConditions = new ValueEnabledModel({
        enabled: ecommerceSettings?.checkoutSettings?.checkoutPolicies?.termsAndConditions?.visible,
        value: ecommerceSettings?.checkoutSettings?.checkoutPolicies?.termsAndConditions?.content,
      });
      this.privacyPolicy = new ValueEnabledModel({
        enabled: ecommerceSettings?.checkoutSettings?.checkoutPolicies?.privacyPolicy?.visible,
        value: ecommerceSettings?.checkoutSettings?.checkoutPolicies?.privacyPolicy?.content,
      });
      this.returnPolicy = new ValueEnabledModel({
        enabled: ecommerceSettings?.checkoutSettings?.checkoutPolicies?.returnPolicy?.visible,
        value: ecommerceSettings?.checkoutSettings?.checkoutPolicies?.returnPolicy?.content,
      });
      this.digitalPolicy = new ValueEnabledModel({
        enabled: ecommerceSettings?.checkoutSettings?.checkoutPolicies?.digitalItemPolicy?.visible,
        value: ecommerceSettings?.checkoutSettings?.checkoutPolicies?.digitalItemPolicy?.content,
      });
      this.contactUs = new ValueEnabledModel({
        enabled: ecommerceSettings?.checkoutSettings?.checkoutPolicies?.contactUs?.visible,
        value: ecommerceSettings?.checkoutSettings?.checkoutPolicies?.contactUs?.content,
      });
      this.customPolicy = new ValueEnabledTitleModel({
        enabled: ecommerceSettings?.checkoutSettings?.checkoutPolicies?.customPolicy?.visible,
        value: ecommerceSettings?.checkoutSettings?.checkoutPolicies?.customPolicy?.content,
        title: ecommerceSettings?.checkoutSettings?.checkoutPolicies?.customPolicy?.title,
      });
      this.checkoutHeader = ecommerceSettings?.checkoutSettings?.checkoutBrand?.header
        ? new CheckoutHeaderModel({
            alignment: ecommerceSettings?.checkoutSettings?.checkoutBrand?.header.alignment,
            displayCheckoutLabel: ecommerceSettings?.checkoutSettings?.checkoutBrand?.header.displayCheckoutLabel,
            logo: {
              size: ecommerceSettings?.checkoutSettings?.checkoutBrand?.header.logo?.size,
            },
          })
        : /* istanbul ignore next */ undefined;
    } else {
      this.storeName = paymentRequestSettings?.storeName ?? undefined;
      this.logoUrl = paymentRequestSettings?.logo?.url ?? undefined;
      this.termsAndConditions = new ValueEnabledModel(paymentRequestSettings?.termsAndConditions);
      this.privacyPolicy = new ValueEnabledModel(paymentRequestSettings?.privacyPolicy);
      this.returnPolicy = new ValueEnabledModel(paymentRequestSettings?.refundCancellationPolicy);
      this.digitalPolicy = new ValueEnabledModel(paymentRequestSettings?.digitalItemPolicy);
      this.contactUs = new ValueEnabledTitleModel(paymentRequestSettings?.contactUs);
      this.customPolicy = new ValueEnabledTitleModel(paymentRequestSettings?.customPolicy);
      this.checkoutHeader = paymentRequestSettings?.checkoutHeader
        ? new CheckoutHeaderModel(paymentRequestSettings?.checkoutHeader)
        : /* istanbul ignore next */ undefined;
    }
    this.isThereAnyPolicyEnabled =
      this.termsAndConditions.enabled ||
      this.privacyPolicy.enabled ||
      this.returnPolicy.enabled ||
      this.customPolicy.enabled;
  }
}
